module.exports = __webpack_public_path__ + "img/new_founder_header.6e412752.png";